module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Sign in","register":"Register"}}')
  delete Component.options._Ctor
}
